import React, {useContext, useEffect, useState} from 'react';
import {FormattedMessage} from "react-intl";

// Material UI
import {ClickAwayListener} from "@mui/material";

// Components
import Badge from "components/Badge";
import CancelTooltipButton from "components/WMS/Mobile/CancelMission/CancelTooltipButton";
import CancelPopup from "components/WMS/Mobile/CancelMission/CancelPopup";

// Context
import {MissionContext} from "../context/MissionContext";
import {WMSContext} from "views/wms/context/WMSContext";

// Utils
import {WmsTaskStatus} from "utils/WMSTaskStatus";

// Assets
import {ReactComponent as DotsIcon} from 'assets/img/wms/more.svg';

function TaskHeaderRightContent({openCancellationPopup = false, setOpenCancelMissionPopup = (isOpen) => {}, itemsToPick = 0}) {
    const [openMenu, setOpenMenu] = useState(false);

    const {currentContainer} = useContext(MissionContext)
    const {currentTask} = useContext(WMSContext)

    const canCancelMission = currentTask?.status === WmsTaskStatus.IN_PROGRESS;

    return (
        <div style={{ display: 'flex', gap: '8px' }}>
            <Badge
                rounded={true}
                isBold={false}
                size={'large'}
            >
                {currentContainer?.name || <FormattedMessage id='wms.myPickingMissions.header.container.name' />}
            </Badge>

            {canCancelMission && (
                <ClickAwayListener onClickAway={() => setOpenMenu(false)}>
                    <div>
                        <DotsIcon onClick={() => setOpenMenu(!openMenu)} />
                        {openMenu && (
                            <div
                                style={{
                                    position: 'absolute',
                                    right: '16px',
                                    top: '54px',
                                    zIndex: 1000,
                                }}
                            >
                                <CancelTooltipButton onClick={() => setOpenCancelMissionPopup(true)} />
                            </div>
                        )}
                        <CancelPopup
                            open={openCancellationPopup}
                            handleClose={() => setOpenCancelMissionPopup(false)}
                            subtitle={<FormattedMessage id={"wms.myPickingMissions.popup.cancel.subtitle"} values={{itemsToPick: itemsToPick}}/>}
                        />
                    </div>
                </ClickAwayListener>
            )}
        </div>
    );
}

export default TaskHeaderRightContent;
